"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ColorPicker: function() {
        return ColorPicker;
    },
    default: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _reactcss = /*#__PURE__*/ _interopRequireDefault(require("reactcss"));
var _input = require("../Input");
var _customColorPicker = require("./CustomColorPicker");
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function hexToRGB(hex) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        var r = parseInt(hex.slice(1, 3), 16);
        var g = parseInt(hex.slice(3, 5), 16);
        var b = parseInt(hex.slice(5, 7), 16);
        return {
            r: r,
            g: g,
            b: b,
            a: 1
        };
    }
    throw new Error("Bad Hex");
}
var ColorPicker = function(props) {
    var onChangeColor = props.onChangeColor, initialValue = props.initialValue, className = props.className;
    var _React_useState = _slicedToArray(_react.default.useState(false), 2), displayColorPicker = _React_useState[0], setDisplayColorPicker = _React_useState[1];
    var _React_useState1 = _slicedToArray(_react.default.useState(hexToRGB(initialValue)), 2), color = _React_useState1[0], setColor = _React_useState1[1];
    var _React_useState2 = _slicedToArray(_react.default.useState(initialValue), 2), colorHex = _React_useState2[0], setColorHex = _React_useState2[1];
    (0, _react.useEffect)(function() {
        if (initialValue) {
            setColor(hexToRGB(initialValue));
            setColorHex(initialValue);
        }
    }, [
        initialValue
    ]);
    var handleClick = function() {
        setDisplayColorPicker(!displayColorPicker);
    };
    var handleClose = function() {
        setDisplayColorPicker(false);
    };
    var handleChange = function(color) {
        setColorHex(color.hex.toUpperCase());
        setColor(color.rgb);
        onChangeColor && onChangeColor(color);
    };
    var styles = (0, _reactcss.default)({
        default: {
            color: {
                background: "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a || 1, ")")
            },
            padding: {
                padding: "3px 0 3px 3px"
            }
        }
    });
    return /*#__PURE__*/ _react.default.createElement("div", null, /*#__PURE__*/ _react.default.createElement(_input.Input, {
        className: "text-gray-500 ".concat(className || ""),
        prefix: /*#__PURE__*/ _react.default.createElement("div", {
            style: styles.padding
        }, /*#__PURE__*/ _react.default.createElement("div", {
            className: "w-8 h-8 rounded border border-gray-200 box-border",
            style: styles.color,
            onClick: handleClick
        })),
        onClick: handleClick,
        value: colorHex,
        type: "color",
        readOnly: true
    }), displayColorPicker && /*#__PURE__*/ _react.default.createElement("div", {
        className: "absolute z-10 mt-2 bg-white"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "fixed inset-0",
        onClick: handleClose
    }), /*#__PURE__*/ _react.default.createElement(_customColorPicker.CustomColorPicker, {
        color: color,
        onChange: handleChange
    })));
};
ColorPicker.defaultProps = {
    initialValue: "#000000"
};
var _default = ColorPicker;

//# sourceMappingURL=ColorPicker.js.map